import React from 'react';
import Panel from 'react-toolbox/lib/layout/Panel';

import {Logo} from '../Common/Logo';
import {GraphPanel} from '../Common/GraphPanel'
import LogoSVG from '../../../images/Bettair_Logo.svg'
import {PanelButton} from "./PanelButton";

export const PanelBody = props => {
    return (
        <Panel className=" col-lg-3 col-sm-3 col-xs-7 paddingLeft5px">
            <div className="row">
                <div className="bettAdminPanel col-lg-12  col-sm-12 col-xs-12">
                    <Logo Logo={LogoSVG}/>
                    <div className="panelElement adminPanel">
                        <PanelButton icon="create"
                                     disabled={props.create.disabled}
                                     onClick={props.create.handle}>Create Polygon</PanelButton>
                        <PanelButton icon="delete_forever"
                                     disabled={props.delete.disabled}
                                     onClick={props.delete.handle}>Delete Polygon</PanelButton>
                        <PanelButton icon="pin_drop"
                                     disabled={props.createSensor.disabled}
                                     onClick={props.createSensor.handle}>{props.createSensor.text}</PanelButton>
                        <PanelButton icon="delete_forever"
                                     disabled={props.deleteSensors.disabled}
                                     onClick={props.deleteSensors.handle}>Delete Sensor Points</PanelButton>
                        <PanelButton icon={props.hideSensors.icon}
                                     disabled={props.hideSensors.disabled}
                                     onClick={props.hideSensors.handle}>{props.hideSensors.text}</PanelButton>
                        <PanelButton icon="wallpaper"
                                     disabled={props.baseMask.disabled}
                                     onClick={props.baseMask.handle}>Generate Base Mask</PanelButton>
                        <PanelButton icon="map"
                                     disabled={props.heatMap.disabled}
                                     onClick={props.heatMap.handle}>Generate Heatmap</PanelButton>
                    </div>
                </div>
            </div>
            {!props.GraphDisabled &&
            <div className="row">
                <div className="bettAdminPanel Aqi col-lg-12  col-sm-12 col-xs-12">
                    <GraphPanel aqiMessages={props.aqi.messages}
                                aqiXAxis={props.aqi.xAxis}
                                isDisabled={!props.aqi.isDisabled}
                                noiseMessages={props.noise.value}
                                noiseXAxis={props.noise.time}
                                noiseChart={props.noise.isDisabled}
                    />
                </div>
            </div>}
        </Panel>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/AdminAppBar/PanelBody.js